import React from 'react';

const traitIcons = {
  Air: '🌬️',
  Earth: '🌱',
  Fire: '🔥',
  Water: '💧',
};

const traitColors = {
  Air: '#60A5FA',
  Earth: '#A3E635',
  Fire: '#F87171',
  Water: '#38BDF8',
};

export default function SiteInfoCard() {
  return (
    <div
      className="rounded-xl shadow-md p-5 mb-4"
      style={{
        background: 'linear-gradient(120deg, #FEF9C3 90%, #FDE68A 100%)',
        border: '1.5px solid #FDE68A',
        minWidth: 260,
        maxWidth: 320,
        color: '#444',
        fontFamily: 'inherit',
      }}
    >
      <div className="font-bold text-lg mb-2" style={{ color: '#b45309', letterSpacing: '0.01em' }}>Site 1</div>
      <div className="text-xs font-semibold mb-1" style={{ color: '#a16207' }}>ATTRIBUTES</div>
      <ul className="mb-3 text-sm">
        <li><span className="font-medium">Strength:</span> <span style={{ color: '#2563eb' }}>5 – 8</span></li>
        <li><span className="font-medium">Agility:</span> <span style={{ color: '#2563eb' }}>3 – 6</span></li>
        <li><span className="font-medium">Intelligence:</span> <span style={{ color: '#2563eb' }}>7 – 10</span></li>
      </ul>
      <div className="text-xs font-semibold mb-1" style={{ color: '#a16207' }}>TRAITS</div>
      <div className="mb-1 text-sm">
        <span className="font-medium">Desired:</span>{' '}
        <span style={{ color: traitColors['Air'], fontWeight: 600 }}>
          {traitIcons['Air']} Air
        </span>
      </div>
      <div className="mb-1 text-sm">
        <span className="font-medium">Undesired:</span>{' '}
        <span style={{ color: traitColors['Water'], fontWeight: 600 }}>
          {traitIcons['Water']} Water
        </span>
      </div>
      <div className="mb-1 text-sm">
        <span className="font-medium">All traits:</span>{' '}
        {['Fire', 'Water', 'Earth', 'Air'].map(trait => (
          <span key={trait} style={{ color: traitColors[trait], marginRight: 8, fontWeight: 600 }}>
            {traitIcons[trait]} {trait}
          </span>
        ))}
      </div>
    </div>
  );
} 